import React from "react";
import { LinkButtonPrimary } from "@ui/buttons";
import Container from "@ui/container";

const NotFound = (props) => {
    return (
        <>
            <Container className="mt-6">
                <div className="md:max-w-md">
                    <h1 className="text-skin-dark font-semibold text-xl mb-5 mt-4">
                        We can't find the page you're looking for.
                    </h1>
                    <LinkButtonPrimary
                        className="md:max-w-[300px]"
                        url="/"
                        external={true}
                    >
                        Go to the Home page
                    </LinkButtonPrimary>
                </div>
            </Container>
        </>
    );
};

export default NotFound;
